module.exports = __webpack_public_path__ + "static/img/island Institute.7003f73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/island Institute.jpg
// module id = y6D+
// module chunks = 1